export default "__VITE_ASSET__bc9tK9nu__"